import { render, staticRenderFns } from "./MapSquare.vue?vue&type=template&id=6445da66&scoped=true&"
import script from "./MapSquare.vue?vue&type=script&lang=js&"
export * from "./MapSquare.vue?vue&type=script&lang=js&"
import style0 from "./MapSquare.vue?vue&type=style&index=0&id=6445da66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6445da66",
  null
  
)

export default component.exports